import { desktopBackgroundImages } from 'source/app/services/UI/Background/DesktopImage/DesktopImage';
import { ESharedFunction } from 'motw_core/Enums/ESharedFunction';
import { CanSetState, SetState } from '../../services/UI/State/SetState';
import { IsMobileDevice } from './Helpers/IsMobile';
import IDevice from './IDevice';
import Background from 'source/app/services/UI/Background/Background';

export default class MobileDevice implements IDevice {
	Initialize = (): void => {
		if (CanSetState(ESharedFunction.Sunrise_progressPercent)) {
			SetState(ESharedFunction.Sunrise_progressPercent, 0);
		}
		
		// if (IsMobileDevice()) {
		// 	desktopBackgroundImages.RandomPreferred().Show();
		// }
	
		Background.ChangeImage();
	};
}
